import { Component } from '@angular/core';
import { NavController,NavParams } from 'ionic-angular';
import { MAX_DATE } from '../../../providers/config/constants';
import { MIN_DATE } from '../../../providers/config/constants';
import { Utils } from '../../../providers/service/utils';
import { AppState } from '../../../app/app.global';

@Component({
  selector: 'page-repeattime',
  templateUrl: 'repeattime.html'
})
export class RepeatTimePage {
	max_date = MAX_DATE;
	min_date = MIN_DATE;
	trip:any;
	
  constructor(public navCtrl: NavController,public params: NavParams,public global: AppState) {
			this.trip =  params.data.trip;
  }

  setCalendar(item:any){
	  	if(item=='0'){
		  	this.trip.endRepeatTime = '0';
	  	}else{
	  		this.trip.endRepeatTime = Utils.dateFormat(new Date(),'yyyy-MM-dd');
	  	}
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/trip/repeattime/repeattime.ts